import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6429830b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import MTournament from '@/modules/MTournament.vue'
import MRankingSection from '@/modules/MRankingSection.vue'
import CTournamentHeader from '@/components/CTournamentHeader.vue'
import CNavigation from '@/components/CNavigation.vue'
import CTournamentsSelection, { TournamentsSelections } from '@/components/CTournamentsSelection.vue'
import CMastersQualificationInfo from '@/components/CMastersQualificationInfo.vue'
import CTournamentsNotAvailable from '@/components/CTournamentsNotAvailable.vue'
import { ERROR_CODES } from '@/model/ErrorCodes'


export default /*#__PURE__*/_defineComponent({
  __name: 'TournamentsView',
  props: {
    tId: {},
    zoneId: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const router = useRouter()
const route = useRoute()
const store = useStore()
const applicationReady = ref(false)

// vue js live cycle method:
onMounted(() => {
  store
    .dispatch('fetchTournament', props.zoneId)
    .then(() => {
      if (props.tId) {
        // if there is a preselcted from URL we load them
        store.commit('setActiveTournament', props.tId)
      } else if (store.state.zone.tournaments.length > 0) {
        store.commit('setActiveTournament', store.state.zone.tournaments[0].tournamentId)
      }
      applicationReady.value = true
    })
    .catch((err: any) => {
      if (err && err.errorCode === 401) {
        router.replace('/extern/login')
      } else {
        router.push({ path: `/error/${(err && err.errorCode) || ERROR_CODES.UNKNOWN}/${props.zoneId}` })
      }
    })

  // scroll to focus
  // not when history is active - otherwise we have jumping page because of scrolling inside MRankingSection
  // ( it was not possible to add the scrolling here because the MRankingSection is not rendered at this time )
  if (route.query.table !== 'history') {
    document.getElementById('app').scrollIntoView({ behavior: 'smooth' })
  }
})

function chooseTournament(tId: string) {
  try {
    store.commit('setActiveTournament', tId)
    router.push(`/tournaments/${props.zoneId}/${tId}`).catch((err) => {})
  } catch (err: any) {
    console.error('Can select specific tournament with ID', tId)
    router.push('/error/' + err.errorCode)
  }
}

const hasTournaments = computed(() => {
  return store.state.zone.tournaments.length > 0
})

const tournamentsSelections = computed((): Array<TournamentsSelections> => {
  return store.state.zone.tournaments
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_t_container = _resolveComponent("t-container")!
  const _component_t_content = _resolveComponent("t-content")!

  return (applicationReady.value)
    ? (_openBlock(), _createBlock(_component_t_content, {
        key: 0,
        main: "",
        class: "tournaments-view",
        "data-qe-id": "tournaments-view"
      }, {
        default: _withCtx(() => [
          _createVNode(CTournamentHeader, {
            zone: _ctx.zoneId,
            language: _ctx.$i18n.locale
          }, null, 8, ["zone", "language"]),
          _createVNode(CNavigation, null, {
            tabs: _withCtx(() => [
              (tournamentsSelections.value.length > 1)
                ? (_openBlock(), _createBlock(CTournamentsSelection, {
                    key: 0,
                    onAction: chooseTournament,
                    "tournaments-selections": tournamentsSelections.value,
                    "selected-t-id": _unref(store).state.tournament.tournamentId
                  }, null, 8, ["tournaments-selections", "selected-t-id"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/",
                "data-qe-id": "back-to-zone-overview-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('tViews.main.button_back')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            (hasTournaments.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(MTournament)
                ]))
              : (_openBlock(), _createBlock(CTournamentsNotAvailable, {
                  key: 1,
                  onGoBack: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
                }))
          ]),
          _createVNode(_component_t_container, null, {
            default: _withCtx(() => [
              _createVNode(MRankingSection),
              (_unref(store).getters.isMastersSelected)
                ? (_openBlock(), _createBlock(CMastersQualificationInfo, {
                    key: 0,
                    class: "masters-info"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})